export default __webpack_public_path__ + "static/media/capsule-ready-large.90957afa.png";